import React, { useLayoutEffect, useState, useRef } from "react";
import PropTypes from "kf-proptypes/widgets";

import { Tooltip, TOOLTIP_POSITION } from "../../feedback/tooltip/index.jsx";

export const OVERFLOWTEXT_TOOLTIP_POSITION = TOOLTIP_POSITION;

/**
 * If text is large and greater than width then ... will come and if user hover that text tooltip will come with full text.
 */

export function OverflowText(props) {
  const {
    children,
    line = 1,
    tooltipContent,
    className = "",
    tooltipPosition = OVERFLOWTEXT_TOOLTIP_POSITION.TOP,
    ...restProps
  } = props;
  const spanRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  useLayoutEffect(
    function renderChildren() {
      let id = setTimeout(() => {
        if (spanRef && spanRef.current) {
          setShowTooltip(
            spanRef.current.offsetWidth < spanRef.current.scrollWidth ||
              spanRef.current.offsetHeight < spanRef.current.scrollHeight
          );
        }
      }, 100);
      return () => clearTimeout(id);
    },
    [children]
  );
  return showTooltip ? (
    <Tooltip
      content={tooltipContent || children}
      position={tooltipPosition}
      mouseEnterDelay={1}
    >
      <span
        className={`ellipsis${line > 1 ? line : ""} ${className}`}
        ref={spanRef}
        data-component="overflowtext"
        dir="auto"
        {...restProps}
      >
        {children}
      </span>
    </Tooltip>
  ) : (
    <span
      className={`ellipsis${line > 1 ? line : ""} ${className}`}
      ref={spanRef}
      data-component="overflowtext"
      {...restProps}
    >
      {children}
    </span>
  );
}

OverflowText.propTypes = {
  /**
   * Text or node to display in normal
   */
  children: PropTypes.node,
  /**
   *  Text or node to display in tooltip
   */
  tooltipContent: PropTypes.node,
  /**
   * max line to display and after that space tooltip will come
   */
  line: PropTypes.number,
  /**
   * To override css properties of the overflowtext
   */
  className: PropTypes.string,
  /**
   * we can change the position of tooltip like top, left, right, bottom
   */
  tooltipPosition: PropTypes.oneOf(Object.values(OVERFLOWTEXT_TOOLTIP_POSITION))
};

OverflowText.defaultProps = {
  line: 1,
  tooltipPosition: OVERFLOWTEXT_TOOLTIP_POSITION.TOP
};
